import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PostCallWithErrorResponse } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { ToastMsg } from "../TostMsg";
import { AppContext } from "../../context/AppContext";

const LoginWithOtp = ({ setLoggedIn }) => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1); // 1 = email, 2 = otp
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState({ d1: "", d2: "", d3: "", d4: "" });
    const [emailErr, setEmailErr] = useState("");
    const [otpErr, setOtpErr] = useState("");

    const [isOtpSending, setIsOtpSending] = useState(false)

    const { storeLoginData } = useContext(AppContext)

    const [state, setState] = useState({
        otpDigit1: "",
        otpDigit2: "",
        otpDigit3: "",
        otpDigit4: "",
    });

    const handleEnter = (event) => {
        var validkeys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
        if (validkeys.includes(event.key)) {
            event.target.value = event.key;
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 1] && form.elements[index + 1].focus();
            event.preventDefault();
        }
    };

    const handleSendEmail = () => {
        if (!email) { setEmailErr("Please enter email"); return; }

        if (isOtpSending) return;

        let payload = {
            email: email,
            otp: null
        }

        setIsOtpSending(true)
        PostCallWithErrorResponse(ApiConfig.LOGIN_WITH_OTP, JSON.stringify(payload)).then((res) => {


            if (res?.json?.Success) {
                setStep(2);
                ToastMsg('success', res?.json?.Message || "OTP sent to your email")
            } else {
                ToastMsg('error', res?.json?.Message || "Failed to send OTP")
            }
            setIsOtpSending(false)


        })
    };

    const handleOtpKeyDown = (e, digit) => {
        if (String(e.key).match("^[0-9]+$")) {
            setOtp((prev) => ({ ...prev, [digit]: e.key }));
            const form = e.target.form;
            const index = [...form].indexOf(e.target);
            form.elements[index + 1]?.focus();
            e.preventDefault();
        }
    };

    const handleSubmitOtp = () => {
        const otpVal = state.otpDigit1 + state.otpDigit2 + state.otpDigit3 + state.otpDigit4;
        if (otpVal.length < 4) { ToastMsg('error', 'Enter Otp Please !'); return; }
        let payload = {
            email: email,
            otp: otpVal
        }
        PostCallWithErrorResponse(ApiConfig.LOGIN_WITH_OTP, JSON.stringify(payload)).then((res) => {

            if (res?.json?.Success) {
                ToastMsg('success', res?.json?.Message || "OTP verified successfully")

                storeLoginData(res, setLoggedIn)


            } else {
                ToastMsg('error', res?.json?.Message || "Invalid OTP, please try again")
            }


        })
    };

    return (
        <main>
            <div className="main-auth createAccount" id="change-password-main">
                <div className="create-ac-form">
                    <form>
                        <div className="top-heading">
                            <div>
                                <label className="heading">
                                    {step === 1 ? "Login with OTP" : "Otp Verification"}
                                </label>
                            </div>
                        </div>

                        {/* Step 1 — Email */}
                        {step === 1 && (
                            <div className="changePassPaddin">
                                <div className="form-control-div">
                                    <label htmlFor="emailInput" className="form-label">
                                        Email Address
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="emailInput"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => { setEmail(e.target.value); setEmailErr(""); }}
                                    />
                                    {emailErr && (
                                        <span className="text-danger text-center">{emailErr}</span>
                                    )}
                                </div>
                                <div className="ac-button">
                                    <button type="button" onClick={handleSendEmail}>
                                        Send OTP
                                    </button>
                                </div>
                                <div className="need">

                                    <p><Link to="/">Login With Password</Link></p>
                                </div>
                            </div>
                        )}

                        {/* Step 2 — OTP */}
                        {step === 2 && (
                            <div className="changePassPaddin">
                                <div className="otp-section-main">
                                    <div className="text">
                                        <label>Enter the Otp to <span>{email}</span></label>
                                    </div>
                                    <div className="input-otp">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="otp-input"
                                            maxLength={1}
                                            placeholder="0"
                                            value={state.otpDigit1}
                                            onKeyDown={(e) => {

                                                if (e.key === "Backspace") {
                                                    setState({ ...state, otpDigit1: "" });
                                                    return
                                                }

                                                if (String(e.key).match("^[0-9]+$")) {
                                                    setState({ ...state, otpDigit1: e.key });
                                                    handleEnter(e);
                                                }
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="otp-input"
                                            maxLength={1}
                                            placeholder="0"
                                            value={state.otpDigit2}
                                            onKeyDown={(e) => {

                                                if (e.key === "Backspace") {
                                                    setState({ ...state, otpDigit2: "" });
                                                    return
                                                }
                                                if (String(e.key).match("^[0-9]+$")) {
                                                    setState({ ...state, otpDigit2: e.key });
                                                    handleEnter(e);
                                                }
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="otp-input"
                                            maxLength={1}
                                            placeholder="0"
                                            value={state.otpDigit3}
                                            onKeyDown={(e) => {
                                                if (e.key === "Backspace") {
                                                    setState({ ...state, otpDigit3: "" });
                                                    return
                                                }
                                                if (String(e.key).match("^[0-9]+$")) {
                                                    setState({ ...state, otpDigit3: e.key });
                                                    handleEnter(e);
                                                }
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="otp-input"
                                            maxLength={1}
                                            placeholder="0"
                                            value={state.otpDigit4}
                                            onKeyDown={(e) => {
                                                if (e.key === "Backspace") {
                                                    setState({ ...state, otpDigit4: "" });
                                                    return
                                                }
                                                if (String(e.key).match("^[0-9]+$")) {
                                                    setState({ ...state, otpDigit4: e.key });
                                                    handleEnter(e);
                                                }
                                            }}
                                        />
                                    </div>



                                </div>
                                <div className="ac-button">
                                    <button type="button" onClick={handleSubmitOtp}>
                                        Submit
                                    </button>
                                </div>
                                <div className="need">
                                    <p>
                                        <label
                                            style={{ cursor: "pointer", color: "var(--brand-primary)", textDecoration: "underline" }}
                                            onClick={() => {
                                                handleSendEmail()
                                                setOtp({ d1: "", d2: "", d3: "", d4: "" }); setOtpErr("");
                                            }}
                                        >
                                            Resend OTP
                                        </label>
                                    </p>
                                    <p><Link to="/">Login With Password</Link></p>
                                </div>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </main>
    );
};

export default LoginWithOtp;